import { PlanType } from "../types/Plan";

// Curated subcategory allowlist per plan type. The importer dropdown reads
// from here; HabitDetailScreen groups Explore Plans by these values.
//
// `id` is the persisted slug (used for grouping/filtering).
// `name` is the display label rendered as the section header.
//
// Free-text values are not blocked at the schema level — admins can still set
// arbitrary subcategories via direct Plan edits if needed — but the importer
// always offers this curated list.

export type PlanSubcategory = {
  id: string;
  name: string;
};

export const PLAN_SUBCATEGORIES: Record<PlanType, PlanSubcategory[]> = {
  exercise: [
    { id: "back", name: "Back" },
    { id: "chest", name: "Chest" },
    { id: "legs", name: "Legs" },
    { id: "arms", name: "Arms" },
    { id: "shoulders", name: "Shoulders" },
    { id: "glutes", name: "Glutes" },
    { id: "core", name: "Core" },
    { id: "full_body", name: "Full body" },
    { id: "push_pull_legs", name: "Push / Pull / Legs" },
    { id: "upper_lower", name: "Upper / Lower" },
    { id: "powerbuilding", name: "Powerbuilding" },
    { id: "hypertrophy", name: "Hypertrophy" },
    { id: "conditioning", name: "Conditioning" },
  ],
  diet: [
    { id: "weight_loss", name: "Weight loss" },
    { id: "muscle_gain", name: "Muscle gain" },
    { id: "maintenance", name: "Maintenance" },
    { id: "recomp", name: "Recomposition" },
    { id: "cut", name: "Cut" },
    { id: "bulk", name: "Bulk" },
  ],
  meditation: [
    { id: "focus", name: "Focus" },
    { id: "sleep", name: "Sleep" },
    { id: "anxiety", name: "Anxiety" },
    { id: "stress", name: "Stress" },
    { id: "mindfulness", name: "Mindfulness" },
  ],
  learning: [
    { id: "language", name: "Language" },
    { id: "technical", name: "Technical" },
    { id: "general", name: "General" },
  ],
  sleep: [
    { id: "hygiene", name: "Sleep hygiene" },
    { id: "recovery", name: "Recovery" },
  ],
  mixed: [],
};

export const getSubcategoriesFor = (planType?: PlanType): PlanSubcategory[] => {
  if (!planType) return [];
  return PLAN_SUBCATEGORIES[planType] ?? [];
};

export const findSubcategoryById = (
  planType: PlanType | undefined,
  id: string | undefined
): PlanSubcategory | undefined => {
  if (!planType || !id) return undefined;
  return getSubcategoriesFor(planType).find((s) => s.id === id);
};
